import { useContext } from 'react'
import { IoCheckmarkDone } from "react-icons/io5";
import { IoCheckmark } from "react-icons/io5";
import { DataProvider } from '../store/ContextProvider';

function TicketList({ getTickets, perPage, setPerPage, currentPage, setCurrentPage, totalPages, totalCount }) {

    const { handleViewTicketsId } = useContext(DataProvider)

    const handleAction = (ticketId) => {
        handleViewTicketsId(ticketId)
        window.open(`/ticket/${ticketId.toLowerCase()}`)
    }

    return (
        <div>
            <div className="w-full overflow-auto min-h-[45vh]">
                <table className="w-full border-spacing-y-1 border-separate">
                    <thead>
                        <tr className="text-secondary-400">
                            <th className="py-3 px-2 rounded-l-xl bg-purple-100">Ticket ID</th>
                            <th className="py-3 px-2 bg-purple-100">Subject</th>
                            <th className="py-3 px-2 bg-purple-100 hidden md:table-cell">Message</th>
                            <th className="py-3 px-2 bg-purple-100 hidden md:table-cell">Raised On</th>
                            <th className="py-3 px-2 rounded-r-xl bg-purple-100">Action</th>
                        </tr>
                    </thead>
                    <tbody>
                        {
                            getTickets.length > 0 ?
                                getTickets.map((ticket, i) => (
                                    <tr className={`text-sm text-center hover:text-gray-400 hover:cursor-pointer ${ticket?.status ? "text-gray-500" : "font-semibold"}`} key={i} onClick={() => handleAction(ticket?.ticketId)}>
                                        <td className="py-3 px-2 rounded-l-xl bg-white" title={ticket?.description || "No Data"}>
                                            <p className="line-clamp-2">{ticket?.ticketId || "N/A"}</p>
                                        </td>
                                        <td className="py-3 px-2 bg-white" title={ticket?.message || "No Data"}>
                                            <p className="line-clamp-2">{ticket?.subject || "N/A"}</p>
                                        </td>
                                        <td className="py-3 px-2 bg-white hidden md:table-cell">
                                            <p className="line-clamp-2">{ticket?.message || "N/A"}</p>
                                        </td>
                                        <td className="py-3 px-2 bg-white hidden md:table-cell">
                                            <p className="line-clamp-2">
                                                {new Date(ticket?.createdAt).toLocaleString("en-IN", {
                                                    day: "2-digit",
                                                    month: "short",
                                                    year: "numeric",
                                                    hour: "2-digit",
                                                    minute: "2-digit",
                                                    hour12: true
                                                }) || "N/A"}
                                            </p>
                                        </td>
                                        <td className="py-3 px-2 bg-white rounded-r-xl">
                                            <div className="flex justify-center">
                                                <span
                                                    className={`inline-flex items-center justify-center gap-1 px-2 py-1 rounded-full font-semibold text-xs ${ticket?.status === 'raised'
                                                        ? 'bg-orange-50 text-orange-700'
                                                        : 'bg-teal-50 text-teal-700'
                                                        }`}
                                                >
                                                    {ticket?.status === 'raised' ? (
                                                        <>
                                                            Pending
                                                            <IoCheckmark />
                                                        </>
                                                    ) : (
                                                        <>
                                                            Resolved
                                                            <IoCheckmarkDone />
                                                        </>
                                                    )}
                                                </span>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                                :
                                <tr>
                                    <td colSpan={5}>
                                        <div className="py-6 px-2 flex justify-center items-center">
                                            <p className="text-gray-500 text-sm">No tickets found</p>
                                        </div>
                                    </td>
                                </tr>
                        }
                    </tbody>
                </table>
            </div>

            <div className="mt-6 flex flex-col md:flex-row items-center justify-between gap-3">

                <div className="flex items-center justify-center gap-3 flex-1">
                    <label className="text-sm">Items per page</label>
                    <select value={perPage} onChange={e => setPerPage(e.target.value)} className="border rounded-lg px-3 py-1 text-xs">
                        <option value={5}>5</option>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={25}>25</option>
                        <option value={50}>50</option>
                        <option value={100}>100</option>
                    </select>
                </div>

                <div className="flex items-center justify-center gap-2 flex-1">
                    <button
                        onClick={() => setCurrentPage(Math.max(1, currentPage - 1))}
                        disabled={currentPage <= 1}
                        className={`px-3 py-1 text-xs rounded-lg border ${currentPage <= 1 ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Prev
                    </button>

                    {currentPage} of {totalPages || 1}

                    <button
                        onClick={() => setCurrentPage(((currentPage + 1) > totalPages) ? totalPages : currentPage + 1)}
                        disabled={currentPage >= (totalPages || 1)}
                        className={`px-3 py-1 text-xs rounded-lg border ${currentPage >= (totalPages || 1) ? "opacity-50 cursor-not-allowed" : "bg-slate-500 text-white"}`}
                    >
                        Next
                    </button>
                </div>

                <div className="text-sm text-slate-600 flex-1 text-center">
                    Total {totalCount || 0} result{totalCount <= 1 ? "" : "s"}
                </div>

            </div>
        </div>
    )
}

export default TicketList